import React, { useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getDisputesView } from "../../../../store/dispute/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import { UPDATE_STATUS_DISPUTE } from "../../../../services/ApiCalls";

const DisputeDetail = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  const disputeData = useSelector((s) => s.dispute.disputeViewData);
  const navigate = useNavigate();

  const resolveHandler = async () => {
    try {
      const res = await UPDATE_STATUS_DISPUTE({
        disputeId: disputeData.disputeId,
        disputeStatus: "close",
      });
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/dispute-management");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) dispatch(getDisputesView(id));
  }, [id]);

  return (
    <>
      <section className="disputeDetail position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Link to="/dispute-management" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>
            <Col lg="12" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue">Description:</h5>
              <div className="cardCstm border rounded p-3">
                <p className="m-0">{disputeData?.description}</p>
                <div className="mt-3 d-flex align-items-center justify-content-between gap-10">
                  <p className="text-primary m-0 fw-sbold">
                    {disputeData?.bookingId}
                  </p>
                  <p className="text-danger m-0 fw-sbold">
                    {moment(disputeData?.createdTime).format(
                      "MM-DD-YYYY HH:mm A"
                    )}
                  </p>
                </div>
              </div>
              <div className="btnWrpper text-end mt-3">
                <Button
                  className="d-inline-flex px-5 align-items-center justify-content-end commonBtn px-3"
                  type="button"
                  onClick={resolveHandler}
                  disabled={disputeData?.status === "close"}
                >
                  Resolve
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DisputeDetail;
